/* Flooring Surgeons – "Show more" for collection grids. Progressive enhancement over Dawn pagination.
   £/m² sort ("The Cheapest" / "The Most Expensive", assets/fs-m2-sort.js): the next cards come from a list of product
   URLs in £/m² order (data-m2 + a JSON list from the server, or setOrder() from fs-m2-sort.js) instead of Shopify's
   ?page=N, which is in pack-price order. */
if (!customElements.get('fs-load-more')) {
  customElements.define(
    'fs-load-more',
    class FsLoadMore extends HTMLElement {
      connectedCallback() {
        this.closest('#ProductGridContainer')?.classList.add('fs-has-more');
        this.button = this.querySelector('.fs-more__btn');
        this.button.addEventListener('click', (e) => {
          e.preventDefault();
          this.load();
        });
        const rest = this.querySelector('[data-fs-m2-rest]');
        if (rest) {
          try { this.setOrder(JSON.parse(rest.textContent), 1); } catch (e) { /* plain links still work */ }
        }
        if (this._m2) this.setOrder(...this._m2);
      }

      // £/m² mode: urls = the cards still to show, in order; page = the page the grid shows now
      setOrder(urls, page) {
        this.m2 = urls.slice();
        this.page = page;
        this.shown = parseInt(this.dataset.total, 10) - this.m2.length;
        if (!this.m2.length) { this.remove(); return; }
        this.paint();
      }

      paint() {
        const total = parseInt(this.dataset.total, 10), size = parseInt(this.dataset.size, 10);
        this.querySelector('[data-shown]').textContent = this.shown;
        this.querySelector('[data-step]').textContent = Math.min(size, this.m2.length);
        this.querySelector('.fs-more__bar span').style.width = Math.round((this.shown / total) * 100) + '%';
        const url = new URL(location.href);
        url.searchParams.set('page', this.page + 1);
        this.button.href = url.pathname + url.search;
      }

      async loadM2() {
        const size = parseInt(this.dataset.size, 10);
        const urls = this.m2.slice(0, size);
        const lis = await window.FSM2.cards(urls);
        let grid = document.getElementById('product-grid');
        if (!grid.matches('ul')) grid = grid.querySelector('ul.product-grid') || grid; // search: the list sits inside
        lis.forEach((li) => grid.appendChild(li));
        this.m2 = this.m2.slice(urls.length);
        this.page += 1;
        this.shown += urls.length;
        const url = new URL(location.href);
        url.searchParams.set('page', this.page);
        history.replaceState(history.state, '', url.pathname + url.search);
        lis[0]?.querySelector('a')?.focus({ preventScroll: true });
        if (!this.m2.length) this.remove();
        else this.paint();
      }

      async load() {
        if (this.busy) return;
        if (this.m2) {
          this.busy = true;
          this.button.setAttribute('aria-busy', 'true');
          try {
            await this.loadM2();
          } catch (e) {
            window.location.href = this.button.href;
          } finally {
            this.busy = false;
            this.button.removeAttribute('aria-busy');
          }
          return;
        }
        const next = this.dataset.next;
        if (!next) return;
        this.busy = true;
        this.button.setAttribute('aria-busy', 'true');
        try {
          const html = await fetch(next).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = document.getElementById('product-grid');
          const items = doc.querySelectorAll('#product-grid > li');
          const first = items[0];
          items.forEach((li) => {
            li.classList.remove('scroll-trigger', 'scroll-trigger--offscreen');
            grid.appendChild(document.adoptNode(li));
          });
          const fresh = doc.querySelector('fs-load-more');
          if (fresh) {
            this.dataset.next = fresh.dataset.next;
            this.button.href = fresh.dataset.next;
            this.querySelector('[data-shown]').textContent = fresh.dataset.shown;
            this.querySelector('[data-step]').textContent = fresh.querySelector('[data-step]').textContent;
            this.querySelector('.fs-more__bar span').style.width = fresh.querySelector('.fs-more__bar span').style.width;
          } else {
            this.remove();
          }
          // keep the address honest so refresh / share lands on the furthest page reached
          history.replaceState(history.state, '', next);
          first?.querySelector('a')?.focus({ preventScroll: true });
        } catch (e) {
          window.location.href = next; // fall back to the real page
        } finally {
          this.busy = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
